import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { fetchMyKpi } from "../api/kpi";
import { KpiDetail } from "../features/kpi/KpiDetail";

// صفحة «الأداء» الخاصة بالموظف — أداؤه هو فقط (لوحة /kpi للمديرين منفصلة).
export default function MyPerformancePage() {
  const { t } = useTranslation();
  const [row, setRow] = useState(undefined);

  useEffect(() => {
    fetchMyKpi().then(setRow).catch(() => setRow(null));
  }, []);

  return (
    <AppShell title={t("nav.myPerformance")} subtitle={t("kpi.mine")}>
      <div className="grid gap-6" data-testid="my-performance-page">
        {row === undefined ? (
          <div className="h-40 animate-pulse rounded-3xl bg-muted/50 shadow-neu-sm" data-testid="performance-loading" />
        ) : row ? (
          <KpiDetail row={row} />
        ) : (
          <div
            className="rounded-3xl bg-background p-10 text-center text-sm font-bold text-muted-foreground shadow-neu-in"
            data-testid="performance-empty"
          >
            {t("kpi.emptyMine")}
          </div>
        )}
      </div>
    </AppShell>
  );
}
